export default __webpack_public_path__ + "static/hall-d9c603a967da5edad5765cff5fa57f3a.jpg";